export default __webpack_public_path__ + "static/media/ic_loyalty.39c8ea60.svg";